module.exports = __webpack_public_path__ + "img/syukyaku-tei-back001.c0b84e46.jpg";